<script lang="ts">
    import { ImageLayers } from "./ImageLayers";
    import "@anyways-open/id-editor/dist/iD"; // This imports a global object 'iD'
    import { useResolve } from "svelte-navigator";
    import { LngLat } from "maplibre-gl";
    import {locale} from "svelte-i18n";
    import {get} from "svelte/store";
    import { appManager } from "../../AppManager";
    import type { EditManager } from "./EditManager";
    import { onMount } from "svelte";

    export let manager: EditManager;
    const ready = manager.getReadyStore();
    const view = manager.getViewStore();
    const mapView = manager.getMapViewStore();
    const editApiUrl = manager.getEditApiUrlStore();

    /**
     * This will become 'our' instance of iD
     * It is initialized in `initId` below where it'll be bound to `iDContainer
     */
    let id: any;
    let iDContainer: HTMLElement;

    $: 
        if ($ready && $view === "edit" && 
            typeof iDContainer !== "undefined" &&
            typeof $mapView !== "undefined" &&
            typeof $editApiUrl !== "undefined") {
                if (typeof id === "undefined") {
                    initId().then();
                }
            }

    // mapView.subscribe(v => {
    //     if (typeof id === "undefined") return;
    //     if ($view !== "edit") return;

    //     id.map().zoom(v.zoom);
    //     id.map().center([v.center.lng, v.center.lat]);
    // });

    view.subscribe(v => {
        if (v !== "edit") return;
        if (typeof id === "undefined") return;

        const mv = get(mapView);
        id.map().zoom(mv.zoom);
        id.map().center([mv.center.lng, mv.center.lat]);
    });
 
    // remove all streetside imagery.
    iD.services.mapillary = undefined;
    iD.services.openstreetcam = undefined;
    iD.services.streetside = undefined;

    // remove all imagery layers and add this we support only.
    iD.fileFetcher.cache().imagery = [];
    iD.fileFetcher.cache().imagery = ImageLayers.layers;
    iD.fileFetcher.cache().oci_features = [];
    iD.fileFetcher.cache().oci_resources = [];
    iD.fileFetcher.cache().locales = { en: { rtl: false, pct: 1 }, nl: {rtl: false, pct: 1} };
    iD.localizer.preferredLocaleCodes(get(locale))
    
    // get iD asset path set properly.
    const resolve = useResolve();
    const resolvedAssetPath = resolve("/npm/@anyways-open/id-editor/") + "/";

    async function initId() {
        // change api settings: use editAPI endpoint
        iD.services.osm.urlroot = get(editApiUrl);

        localStorage.setItem("sawSplash", "true");

        // we don't use the OSM-API authentication, fool the iD editor to think it's already authorized again the API.
        // we do this my setting fictional tokens in local storage, never mind them being sent.
        let user = get(await appManager.getCurrentUserStore());
        let defaultComment = `Update by ${user.email}`;
        if (typeof Storage !== "undefined") {
            localStorage.setItem(
                get(editApiUrl) + "oauth_request_token_secret",
                "some_fictional_secret"
            );
            localStorage.setItem(
                get(editApiUrl) + "oauth_token",
                "some_fictional_token"
            );
            localStorage.setItem(
                get(editApiUrl) + "oauth_token_secret",
                "another_fictional_secret"
            );
          
            // set default changeset comment.
            localStorage.setItem("comment", defaultComment);
        }

        // start an initialize iD.
        id = iD
            .coreContext()
            .minEditableZoom(14)
            .assetPath(resolvedAssetPath)
            .apiConnections([
                {
                    urlroot: iD.services.osm.urlroot,
                    oauth_consumer_key:
                        "5A043yRSEugj4DJ5TljuapfnrflWDte8jTOcWLlT",
                    oauth_secret: "aB3jKq1TRsCOUrfOIZ6oQMEDmv2ptV76PA54NGLL",
                },
            ])
            .containerNode(iDContainer);
        var osm = id.connection();
        osm.switch({ urlroot: iD.services.osm.urlroot });

        id.init();

        // respond to event telling us when id is ready.
        id.on("enter.editSvelte", () => {
            // turn off hashing behaviour if present, we do our own.
            if (typeof id.ui().hash !== "undefined") {
                id.ui().hash.off();
            }

            // set default comment.
            id.defaultChangesetComment(defaultComment);

            // make sure map is in correct position intially.
            id.map().zoom(get(mapView).zoom);
            id.map().center([get(mapView).center.lng, get(mapView).center.lat]);
            // the hashing of id has removed the map hash, make sure it is there again.
            mapView.set(get(mapView));

            // register map move.
            id.map().on("move.editSvelte", () => {
                if (get(view) !== "edit") return;

                // report map state.
                const zoom = id.map().zoom();
                const idCenter = id.map().center();
                const center = new LngLat(idCenter[0], idCenter[1]);
                mapView.set({
                    center: center,
                    zoom: zoom
                });

                // overwrite
                if (typeof Storage !== "undefined") {
                    localStorage.setItem(
                        "comment",
                        `Update @ ${center.lng.toFixed(5)}/${center.lat.toFixed(
                            5
                        )}`
                    );
                }
            });
        });
    }
</script>

<svelte:head>
    <title>ANYWAYS | Edit</title>
</svelte:head>

<div bind:this={iDContainer} />

<style>
</style>
